import Icon from "@components/Icon/Icon";
import Button from "@src/app/components/AccessibleComponents/Button";
import loadQueryly from "@src/app/util/loadQueryly";

import styles from "./SearchTrigger.module.css";

export default function SearchTrigger() {
  return (
    <Button
      aria-label="Search"
      onPress={() => {
        loadQueryly().then((queryly) => {
          queryly.opensearch();
        });
      }}
      className={styles.searchButton}
    >
      <Icon type="search" />
    </Button>
  );
}
